import {BookOpen, Cog, FileText, Home, Users} from "lucide-react";

export const menuItems = [
    {
        href: "/dashboard",
        label: "Tableau de bord",
        icon: <Home className="h-5 w-5" />
    },

    // {
    //     label: "Documentation",
    //     icon: <BookOpen className="h-5 w-5" />,
    //     permissions: [],
    //     href: "/dashboard/administration/documentation",
    // },

    {
        label: "Dossiers",
        icon: <FileText className="h-5 w-5" />,
        permissions: ["LIST_COURRIER_ARRIVE"],
        href: "/dashboard/dossiers",
    },

    {

        label: "Publications",
        icon: <BookOpen className="h-5 w-5" />,
        permissions: ["list_publications"],
        href: "/dashboard/administration/publications",
    },
];
